<template>
    <div v-if="type == 'hp_testimonial'">
        <p class="mb-1 pl-1 text-left text-white">Parents</p>
        <b-card style="border:none;border-radius: 10px;" class="mb-2 h-100 hp_testimonial">
            <div @click="openYtModal(media)" style="height:auto;overflow: hidden;background: black;">
                <div  class="h-100">
                    <img style="cursor: pointer;border-radius: 0px 0px 20px 20px;" src="https://images.avishkaar.cc/workflow/vue/videoPlaceholde.png" class="w-100 h-100" alt="">
                    <p v-if="text" class="text-white py-2 px-2 " style="position: relative;bottom: 60px;background: rgb(0,0,0,0.5);">{{text}}</p>
                </div>
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'win_testimonial'">
        <b-card style="border:none;border-radius: 10px;" class="mb-2 h-100 hp_testimonial">
            <div class="overlay_img" :style="'background: linear-gradient(0deg, rgba(48, 48, 48, 0.8), rgba(48, 48, 48, 0), rgba(48, 48, 48, 0)), url('+media+')'" > 
                <!-- <img :src="media" alt=""> -->
                <div class="win_text text-white px-4">
                    <p class="text-white m-0 text-capitalize"><strong>{{user_name}}, {{user_age}}</strong></p>
                    {{win_text}}
                </div>
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'hp_text_testimonial'">
        <b-card style="border:none;border-radius: 10px;" class="mb-2 h-100 hp_text_testimonial">
            <div class="pt-5">
                <div class=" text-white px-lg-4">
                    <img :src="media" alt="" style="height: 50px;width: 50px;border-radius: 50%;" loading="lazy">
                    <p class="text-white mb-1 mt-3 col-lg-9 col-12 mx-auto hp_text_t px-0" style="font-weight: 300;"><i>"{{win_text}}"</i></p>
                    <p class="text-white mb-0 mt-4 text-capitalize"><strong>{{user_name}}, {{user_type}}</strong></p>
                </div>
            </div>
        </b-card>
    </div>
    <div v-else>
        <b-card style="border:none;border-radius: 16px;" class="mb-2 h-100">
            <div style="height:30vh;overflow: hidden;border-radius: 0px 0px 20px 20px;" v-if="type == 'image_text' || extension == 'png' || extension == 'jpg' || extension == 'jpeg'">
                <div class="h-100">
                    <img style="border-radius: 0px 0px 20px 20px;" :src="type == 'image_text' ? media : 'https://ddzoxiigsfbyr.cloudfront.net/' + media" class="w-100 h-100" alt="">
                    <p v-if="text" class="text-white py-2 px-2 text-scroll" style="position: relative;overflow: scroll;height: 70px;bottom: 60px;background: rgb(0,0,0,0.5);">{{text}}</p>
                </div>
            </div>
            <div style="height:30vh;overflow: hidden;border-radius: 0px 0px 20px 20px;" v-else-if="type == 'video_text'">
                <div @click="openYtModal(media)" class="h-100">
                    <img style="cursor: pointer;border-radius: 0px 0px 20px 20px;" :src="thumbnail_link" class="w-100 h-100" alt="">
                    <p v-if="text" class="text-white py-2 px-2 text-scroll" style="position: relative;bottom: 60px;overflow: scroll;height: 70px;background: rgb(0,0,0,0.5);">{{text}}</p>
                </div>
            </div>
            <div class="text-scroll" style="height:30vh;overflow: scroll;" v-else>
                <div class="px-4 pt-4">
                    <svg width="43" height="38" viewBox="0 0 43 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M38.3466 19.32H31.8233V14.0363C31.8246 12.6354 32.3748 11.2922 33.3532 10.3016C34.3316 9.311 35.6583 8.75393 37.042 8.75266H37.6944C37.9516 8.75325 38.2063 8.7024 38.444 8.60305C38.6817 8.50369 38.8977 8.35779 39.0795 8.1737C39.2614 7.98962 39.4055 7.77098 39.5037 7.53035C39.6019 7.28971 39.6521 7.03181 39.6516 6.77146V2.8087C39.6521 2.54837 39.6019 2.2905 39.5037 2.04989C39.4056 1.80927 39.2615 1.59065 39.0796 1.40657C38.8978 1.22249 38.6819 1.07658 38.4442 0.977206C38.2066 0.877832 37.9519 0.826954 37.6948 0.827494H37.042C35.3285 0.827001 33.6318 1.16832 32.0488 1.83195C30.4657 2.49557 29.0273 3.46851 27.8157 4.69515C26.6041 5.9218 25.6431 7.37813 24.9877 8.98092C24.3322 10.5837 23.995 12.3016 23.9954 14.0363V33.8501C23.9957 34.901 24.4082 35.9088 25.1421 36.6519C25.8761 37.395 26.8714 37.8126 27.9094 37.8129H38.3466C39.3846 37.8126 40.3799 37.395 41.1139 36.6519C41.8478 35.9088 42.2603 34.901 42.2606 33.8501V23.2828C42.2603 22.2319 41.8478 21.2241 41.1139 20.481C40.3799 19.7379 39.3846 19.3203 38.3466 19.32ZM14.8629 19.32H8.33963V14.0363C8.34087 12.6354 8.89109 11.2922 9.8695 10.3016C10.8479 9.311 12.1746 8.75393 13.5582 8.75266H14.2107C14.4678 8.7532 14.7225 8.70232 14.9602 8.60295C15.1978 8.50358 15.4138 8.35766 15.5956 8.17358C15.7774 7.9895 15.9215 7.77088 16.0197 7.53027C16.1178 7.28965 16.1681 7.03178 16.1675 6.77146V2.8087C16.1681 2.54834 16.1179 2.29044 16.0198 2.04978C15.9216 1.80913 15.7775 1.59047 15.5957 1.40635C15.4139 1.22224 15.1979 1.07629 14.9603 0.976897C14.7226 0.877502 14.4679 0.826613 14.2107 0.827153H13.5582C11.8448 0.82666 10.1481 1.16799 8.56497 1.83164C6.98188 2.49529 5.54345 3.46825 4.33187 4.69493C3.12029 5.92162 2.15931 7.37798 1.50383 8.98082C0.848359 10.5837 0.511233 12.3015 0.511719 14.0363V33.8501C0.511987 34.901 0.924435 35.9088 1.65839 36.6519C2.39234 37.395 3.38771 37.8126 4.42567 37.8129H14.8629C15.9008 37.8126 16.8962 37.395 17.6302 36.6519C18.3641 35.9088 18.7766 34.901 18.7768 33.8501V23.2828C18.7766 22.2319 18.3641 21.2241 17.6302 20.481C16.8962 19.7379 15.9008 19.3203 14.8629 19.32Z" fill="#9BC157"/>
                    </svg>
                    <p class="text-left pt-4 text-center" style="color: rgba(48, 48, 48, 0.9);font-size: 13px;">{{text}}</p>
                    {{media}}
                </div>
            </div>
            <div class="py-3">
                <div v-if="userRating" class="d-flex justify-content-center">
                    <div v-for="index in userRating" :key="index">
                        <i class="fas fa-star mx-1" style="color:rgb(250,171,65);font-size: 20px;"></i>
                    </div>
                    <div v-for="index in unRated" :key="'A' + index">
                        <i class="fas fa-star mx-1" style="font-size: 20px;color:#C4C4C4;"></i>
                    </div>
                </div>
                <div v-if="user_name" class="d-flex flex-wrap py-3 px-4 justify-content-md-start justify-content-center">
                    <div v-if="user_image">
                        <img class="review-profile" :src="user_image" alt="" width="100%" height="100%">
                    </div>
                    <div v-else>
                        <img class="review-profile" src="https://avishkaar-images.s3.ap-south-1.amazonaws.com/user-placeholder.png" alt="" width="100%" height="100%">
                    </div>
                    <div class="text-left pl-4 my-auto pt-md-0 pt-2">
                        <p class="m-0" style="color: #303030;"><strong>{{user_name}}</strong></p>
                        <p class="m-0 mt-1" style="font-size: 12px;color: rgba(48, 48, 48, 0.6);">{{user_desgination}}</p>
                    </div>
                </div>
                <div v-else class="d-flex flex-wrap py-3 px-4 justify-content-md-start justify-content-center">
                    <div>
                        <img class="review-profile" src="https://avishkaar-images.s3.ap-south-1.amazonaws.com/user-placeholder.png" alt="" width="100%" height="100%">
                    </div>
                    <div class="text-left pl-4 my-auto pt-md-0 pt-2">
                        <p class="m-0" style="color: #303030;"><strong>Avishkaar</strong></p>
                    </div>
                </div>
            </div>
        </b-card>
        <b-modal id="youtubeModal" ref="youtubeModal" hide-footer hide-header>
            <button type="button" class="hp_modal_btn" @click="closeYtModal"><i class="fas fa-times"></i></button>
            <div class="d-block text-center px-3 pt-3 pb-2">
                <iframe width="100%" height="315" :src="'https://www.youtube.com/embed/' + ytSource" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
  name: "CarouselCard",
  props: ["type","media","text","user_image","user_desgination","user_name","rating","win_text","user_age","user_type","thumbnail_link","extension"],
  data() {
      return {
          userRating: Number(this.rating),
          unRated: 5 - Number(this.rating),
          visible: false,
          ytSource: null
      }
  },
  methods: {
    callback(visible) {
      if (visible) {
        this.visible = true
      }
    },
    openYtModal(src) {
    this.$refs['youtubeModal'].show()
    this.ytSource = src
        document.getElementById('productNav').classList.remove("sticky"); 
        document.getElementById('productNav').classList.remove("hideFilter");
    },
    closeYtModal() {
    this.$refs['youtubeModal'].hide()
    this.ytSource = null
    },
  }
};
</script>
<style  scoped>
.slick-slide {
        width: 340px !important;
}
.card-body {
    padding: 0px;
    background: #FFFFFF;
    border-radius: 20px;
}
.hp_testimonial .card-body {
    border-radius: 10px;
}
.slick-active .card-body{
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.035), 0px -1px 37px rgba(0, 0, 0, 0.07), 0px 0.38599px 1.0172px rgba(0, 0, 0, 0.035) !important;
    opacity: 1 !important;
    overflow: hidden;
}
.review-profile {
    width: 49.12px;
    height: 49.31px;
    background-blend-mode: normal;
    border-radius: 50%;
}
.image_text_h {
    height:50vh;
}
.hp_text_t {
    font-size: 22px;
}
@media only screen and (max-width: 780px) {
    .image_text_h {
    height:40vh !important;
    }
    .hp_text_t {
    font-size: 18px !important;
}
}
.win_text {
    position: absolute;
    bottom: 10px;
    text-align: left;
}
.overlay_img {
    height:40vh;overflow: hidden;    
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center !important;
}
.hp_text_testimonial, .hp_text_testimonial .card-body {
    background: transparent !important;
    box-shadow: none !important;
}
.embed-responsive {
    height: 100%;
}
.text-scroll::-webkit-scrollbar
 {
  width: 8px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
.text-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: transparent;
  background-color: transparent;
}
.hp_modal_btn {
      border: none;
    position: absolute;
    z-index: 2;
    background: #d2691e;
    padding: 0;
    top: -15px;
    right: -15px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
}
</style>